/** ***
------------------------------------------------------------------------
ANOMALY RULES LIST PAGE
------------------------------------------------------------------------
 "active": 12,            
                "anomalyCategory": "LOGIN_ANOMALY",
                "anomalyType": "NEW_USER_HOST_LOGIN",
                "description": "",
                "eventDescription": null,
                "id": 0,
                "staging": null,
                "state": "ENABLED"
            
            "dismissed": 0

** ***/

const anomalyRulesMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'string',
        description: 'Status',
        label: 'Status',
        name: 'state',
        'min-width': 100,
        sortable: true,
        display: 'switch',
        displayKey: {
          active: {
            key: 'ENABLED',
            display: 'Active',
            color: '#77dab4',
            textColor: '#008044',
            icon: ''
          },
          inactive: {
            key: 'DISABLED',
            display: 'Disabled',
            color: '#c6cbd2',
            textColor: '#6a6e75',
            icon: ''
          }
        }
      },
      {
        datatype: 'string',
        description: 'Instance',
        label: 'Instance',
        name: 'description',
        'min-width': 250,
        sortable: true
      },
      {
        datatype: 'string',
        description: 'Anomaly Type',
        label: 'Anomaly Type',
        name: 'anomalyCategory',
        'min-width': 100,
        sortable: true,
        display: 'iconAndText',
        displayKey: [
          {
            key: 'LOGIN_ANOMALY',
            display: 'Login'
          },
          {
            key: 'PROCESS_ANOMALY',
            display: 'Process'
          }
        ]
      },
      {
        datatype: 'string',
        description: 'Detected',
        label: 'Detected',
        name: 'active',
        'min-width': 100,
        sortable: true
      },
      {
        datatype: 'string',
        description: 'Dismissed',
        label: 'Dismissed',
        name: 'dismissed',
        'min-width': 100,
        sortable: true
      }
    ]
  }
}

export { anomalyRulesMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/anomalies/anomaly-rules-meta.js